import { render, staticRenderFns } from "./PersonMsg.vue?vue&type=template&id=6664f7c5&scoped=true&"
import script from "./PersonMsg.vue?vue&type=script&lang=js&"
export * from "./PersonMsg.vue?vue&type=script&lang=js&"
import style0 from "./PersonMsg.vue?vue&type=style&index=0&id=6664f7c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664f7c5",
  null
  
)

export default component.exports